/** Size presets. SVG viewBox is 105x12, all sizes maintain this ratio. */
const SIZES = {
  xs: { width: 105, height: 12 },
  sm: { width: 134, height: 16 },
  md: { width: 236, height: 28 },
  lg: { width: 354, height: 42 },
  xl: { width: 540, height: 64 },
} as const

interface DefconLogoProps {
  size?: keyof typeof SIZES
  className?: string
}

/**
 * DEFCON AI wordmark logo — actual SVG exported from Figma DS.
 *
 * Shows both theme variants simultaneously, hidden/shown via CSS
 * so theme toggles work reactively without re-render. The
 * [data-theme="light"] attribute on <html> controls visibility.
 */
export function DefconLogo({ size = 'md', className = '' }: DefconLogoProps) {
  const { width, height } = SIZES[size]
  return (
    <span
      className={`inline-block relative ${className}`}
      style={{ width, height }}
      role="img"
      aria-label="DEFCON AI"
    >
      {/* Dark theme: light text — visible by default (dark-first) */}
      <img
        src="/brand/defcon-logo.svg"
        alt=""
        width={width}
        height={height}
        className="block [html[data-theme='light']_&]:hidden"
      />
      {/* Light theme: dark text — hidden by default */}
      <img
        src="/brand/defcon-logo-light.svg"
        alt=""
        width={width}
        height={height}
        className="hidden [html[data-theme='light']_&]:block"
      />
    </span>
  )
}
